import './IconBanner.css';

export default function IconBanner() {
    const icons = [
        {
            url:`/images/secure-payment-icon.webp`,
            text:'Bezpieczne płatności'
        },
        {
            url:`/images/fast-shipment-icon.webp`,
            text:'Wysyłka w ciągu 24h'
        },
        {
            url:`/images/comfort-shipment-icon.webp`,
            text:'Wygodna dostawa'
        },
        {
            url:`/images/free-shipment-icon.webp`,
            text:'Darmowa wysyłka od 400zł'
        }
    ]

    return <div id='icon-banner'>
        {icons.map((icon,index)=>{
            return <div className='icon-banner-block' key={index}>
                <div className='icon-banner-image'>
                    <img loading="lazy" src={icon.url} alt={icon.alt || 'Ikona'} />

                </div>
                <div className='icon-banner-text'>{icon.text}</div>
            </div>
        })}
    </div>;
}
